import React from "react";
import Banner from "./Banner";
import Products from "./Products";
import Artical from "./Artical";
import Benefits from "./Benefits";
import Galleary from "./Galleary";
import Category from "./Category";
import Shops from "../Shops/Shops";

const Home = () => {
  return (
    <div>
      <Banner></Banner>
      <div className="max-w-7xl mx-auto">
        <Category></Category>
        <Products></Products>
        <Artical></Artical>
        <Galleary></Galleary>
        <Benefits></Benefits>
        <Shops></Shops>
      </div>
    </div>
  );
};

export default Home;
